<template>
  <teleport to="body">
    <!-- Backdrop -->
    <div v-if="modelValue" :class="$style.backdrop" @click="close" />

    <!-- Slide-down panel -->
    <div :class="[$style.panel, modelValue ? $style.panelOpen : '']">
      <div :class="$style.headerRow">
        <div :class="$style.title">{{ $t("player-menu") }}</div>
        <div title="Close this box" :class="[$style.closeIconContainer]" @click="close">
          <img :class="$style.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>

      <div :class="$style.body">
        <!-- Replace these placeholders with real content later -->
        <div v-if="user.name" :class="$style.item">
          <div :class="$style.itemLabel">{{ $t("name") }}</div>
          <div :class="$style.itemText">{{ user.name }}</div>
        </div>
        <!-- <div v-if="playersJoined" :class="$style.item">
          <div :class="$style.itemLabel">{{ $t("players") }}</div>
          <div :class="$style.itemText">{{ playersJoined }}</div>
        </div> -->
        <div v-if="host.name" :class="$style.item">
          <div :class="$style.itemLabel">{{ $t("host-name") }}</div>
          <div :class="$style.itemText">{{ host.name }}</div>
        </div>
        <div v-if="playerGroup?.name" :class="$style.item">
          <div :class="$style.itemLabel">{{ $t("group") }}</div>
          <div :class="$style.itemText">{{ playerGroup.name }}</div>
        </div>
        <div v-if="showRoleButton" :class="$style.headerItem">
          <HeaderItemButton
            :text="$t('see-role')"
            :clickFunction="handleOpenRoleModal"
            backBg="#000000"
            frontBg="#676767"
            textColor="#ffc642"
            :button-width="isMobile ? '92px' : isTablet ? '104px' : '116px'"
          />
        </div>
        <div v-if="gameWinner" :class="$style.item">
          <div :class="$style.itemLabel">{{ gameWinner === "None" ? $t("result") : $t("game-winner") }}</div>
          <div :class="[$style.itemText, $globalStyle.headerItemPlayerWinnerText]">
            {{ gameWinner === "None" 
                ? $t("game-tied") 
                : gameWinner === "Players" 
                  ? $t("players") 
                  : gameWinner === "Saboteur" 
                    ? $t("saboteur") 
                    : gameWinner 
            }}
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import styles from "@/css/mobileHeader.module.css";
import globalStyles from "@/css/global.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import HeaderItemButton from "../buttons/HeaderItemButton.vue";
import useDeviceType from "@/utils/useDeviceType";

const $style = styles;
const $globalStyle = globalStyles;
const closeIcon = CloseIcon;
const device = useDeviceType();

// eslint-disable-next-line
const props = defineProps({
  modelValue: { type: Boolean, required: true },
  user: { type: Object, required: true },
  playersJoined: { type: Number, required: true },
  host: { type: Object, required: true },
  playerGroup: { type: Object, required: false, default: () => {} },
  realTextLabel: { type: String, required: true },
  isSaboteur: { type: Boolean, required: false, default: false },
  saboteur: { type: Object, required: false, default: () => {} },
  gameWinner: { type: String, required: false, default: "" },
  showRoleButton: { type: Boolean, required: false, default: false },
  openRoleModal: { type: Function, required: true },
});

// eslint-disable-next-line
const emit = defineEmits(["update:modelValue"]);

const isMobile = device.isMobile.value;
const isTablet = device.isTablet.value;

function close() {
  emit("update:modelValue", false);
}

function handleOpenRoleModal() {
  close();
  props.openRoleModal();
}
</script>

<style scoped></style>
